<template>
  <div class="payment-success">
    <div class="success">
      <AmIconMaterial
        class="success__icon text--green"
        name="check_circle"
        size="md"
      />
      <AmTypography
        :text="$t('steps.payment.paymentProcessSuccess.title')"
        text-color="success"
        typography-style="l6"
        weight="bold"
      />
    </div>

    <div>
      <AmTypography
        :class="`text--${theme.color}`"
        :text="$t('steps.payment.yourData')"
        typography-style="l5"
        weight="bold"
      />
      <br />
      <ContactAddress />
    </div>
    <div>
      <AmTypography
        :class="`text--${theme.color}`"
        :text="$t('steps.payment.purchaseSummary.title')"
        typography-style="l5"
        weight="bold"
      />
      <br />
      <PurchaseSummary
        :installmentSeletedLabel="installmentSeletedLabel"
        :paymentType="paymentType"
      />
    </div>
    <br />
    <div id="redirectButtonText">
      <AmTypography
        :text="$t('steps.payment.shopify.paymentSucess')"
        typography-style="l6"
        text-color="success"
        weight="bold"
      />
    </div>
    <br />
    <AmButton
      :class="`next ${theme.color}`"
      :label="buttonLabel"
      size="xl"
      full-width
      @click="returnToStore()"
    />
  </div>
</template>

<script>
import themeMixin from '@/components/mixins/themeMixin'
import { mapState } from 'vuex'
import { injectPixelScript } from '@/utils/pixels/injectPixelScript'
import { pixelPurchaseParams } from '@/utils/pixels/pixelPurchaseParams'
import ContactAddress from '@/views/Checkout/partials/ContactAddress/Shopify/ContactAddress.vue'
import PurchaseSummary from '@/views/Checkout/partials/PurchaseSummary/Shopify/PurchaseSummary.vue'

export default {
  name: 'PaymentSuccess',
  components: {
    ContactAddress,
    PurchaseSummary,
  },
  mixins: [themeMixin],
  props: {
    paymentType: {
      type: String,
    },
    installmentSelected: {
      type: [String, Object],
    },
    paymentSuccessData: {
      type: Object,
    },
  },
  data() {
    return {
      paymentTypesChangePaymentButton: ['billet', 'pix'],
    }
  },
  computed: {
    ...mapState('Checkout', {
      cart: (state) => state.cart,
      pixels: (state) => state.pixels,
    }),
    buttonLabel() {
      return this.$t('returnToStore')
    },
    installmentSeletedLabel() {
      return this.installmentSelected.label
    },
  },
  async mounted() {
    this.loadCheckoutPixel()
  },
  methods: {
    returnToStore() {
      window.location.href = this.paymentSuccessData.redirect_url
    },
    loadCheckoutPixel() {
      try {
        const pixels = pixelPurchaseParams(this.pixels, this.cart, 'credit_card')

        if (pixels.length) {
          injectPixelScript(pixels, 'purchase')
        }
      } catch (error) {
        throw new Error(error)
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.payment-success {
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin-bottom: 30px;

  .success {
    display: flex;
    justify-content: center;
    margin: 30px 10px;

    &__icon {
      margin-right: 10px;
    }
  }

  .instruction {
    margin-bottom: 10px;
    text-align: center;
  }

  .return-store {
    margin-top: 23px;
  }

  #redirectButtonText {
    display: flex;
    margin: 0 auto;
  }
}
</style>
